<div class="main-container">
  <div class="header-container">
    <label class="header-text" [innerText]="'QUALITY CHECK'"></label>
    <!--<div class="back-to-scheduler-container" routerLink="/scheduler/uploadReport">
            <span class="back">GO BACK</span>
            <div class="rounded-btn-prev" role="button" inlineSVG="/assets/icons/prev.svg"></div>
        </div>-->
  </div>
  <h2>{{media?.name}}</h2>
  <div class="media-info-container">
    <div class="column">
      <div class="media-container">
        <video-container
          [media]="media"
          [subtitles]="media?.subtitles"
          [audio]="media?.audioFiles"
          [posterUrl]="media?.contentSnapshotUrl"
          [subtitleOffsetMs]="qcPreviewSubtitleOffsetMs"
          [videoUrl]="videoUrl"
          [framerate]="media?.contentFps ?? 0"
        >
        </video-container>
      </div>
    </div>
    <div class="column">
      <div class="labels-container">
        <label class="label-header">Duration:</label>
        <label class="label-content"
          >{{!!media?formatMediaDuration(media.contentDuration):''}}</label
        >
      </div>
      <div class="labels-container">
        <label class="label-header">Audio Channel Count:</label>
        <label class="label-content">{{media?.channelCount}}</label>
      </div>
      <div class="labels-container">
        <label class="label-header">Audio Sample Rate:</label>
        <label class="label-content"
          >{{!!media && !!media.sampleRate ? media.sampleRate + 'Hz':
          ''}}</label
        >
      </div>
      <div class="labels-container">
        <label class="label-header">Max Volume:</label>
        <label class="label-content"
          >{{!!media ? formatGeneralVolume(media.generalVolume) : ''}}</label
        >
      </div>
    </div>
    <div class="column">
      <div class="labels-container">
        <label class="label-header">Alpha:</label>
        <label class="label-content"
          >{{!!media ? (media.contentHasAlpha ? 'Yes' : 'No') : ''}}</label
        >
      </div>
      <div class="labels-container">
        <label class="label-header">Media Type:</label>
        <label class="label-content"
          >{{!!media ? formatMediaType(media.contentMediaType) : ''}}</label
        >
      </div>
      <div class="labels-container">
        <label class="label-header">Resolution:</label>
        <label class="label-content"
          >{{!!media ? media.contentWidth + 'x' + media.contentHeight :
          ''}}</label
        >
      </div>
      <div class="labels-container">
        <label class="label-header">Video Frames Per Second:</label>
        <label class="label-content">{{!!media ? media.contentFps : ''}}</label>
      </div>
    </div>
    <div class="column">
      <div class="labels-container">
        <label class="label-header">Snapshot:</label>
        <label class="label-content">Yes</label>
      </div>
      <div class="labels-container">
        <label class="label-header">Frame Format:</label>
        <label class="label-content"
          >{{!!media ? formatFrameFormat(media.frameFormat) : ''}}</label
        >
      </div>
    </div>
  </div>

  <div class="table-header">
    <div class="alert-count-header">Alerts</div>
    <div class="alert-count">Found {{records.length}} Alerts</div>
  </div>
  <ngx-datatable
    class="bootstrap horiz-border gray-bg"
    style="min-height: 575px"
    [rows]="records"
    [sorts]="sorts"
    [limit]="10"
    [count]="total"
    [rowHeight]="50"
    [footerHeight]="50"
    [loadingIndicator]="isLoading"
    [columnMode]="'force'"
    [selectionType]="$any('checkbox')"
    [selected]="selected"
    [scrollbarV]="records.length > 10"
    (activate)="onActivate($event)"
    (select)="onSelect($event)"
  >
    <ngx-datatable-column
      prop="severity"
      name="Severity"
      [cellClass]="getCellClass.bind(this)"
    >
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div [class]="'table-row severity severity-'+formatSeverity(value)">
          {{formatSeverity(value) | uppercase}}
        </div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      prop="issueType"
      name="Issue Type"
      class="table-row"
      [cellClass]="getCellClass.bind(this)"
    ></ngx-datatable-column>
    <ngx-datatable-column
      prop="snapshot"
      name="Snapshot"
      [sortable]="false"
      [cellClass]="getCellClass.bind(this)"
    >
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <img
          [src]="value || placholderSnapshotImage"
          width="62px"
          height="36px"
          (click)="openPreview(row)"
          class="table-row qc-snapshot"
        />
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      prop="startTime"
      name="From"
      [cellClass]="getCellClass.bind(this)"
      [comparator]="TimeSortFunction"
    >
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div class="table-row">{{formatDuration(value)}}</div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      prop="endTime"
      name="To"
      [cellClass]="getCellClass.bind(this)"
      [comparator]="TimeSortFunction"
    >
      <ng-template let-value="value" ngx-datatable-cell-template
        >{{formatDuration(value)}}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      prop="duration"
      name="Duration"
      [cellClass]="getCellClass.bind(this)"
      [comparator]="TimeSortFunction"
    >
      <ng-template let-value="value" ngx-datatable-cell-template
        >{{formatDuration(value)}}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column
      prop="description"
      name="Details"
      [cellClass]="getCellClass.bind(this)"
    >
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div class="description-ellipsis" [title]="value">{{value}}</div>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column [sortable]="false" [checkboxable]="true">
      <ng-template ngx-datatable-header-template>
        <label
          class="datatable-checkbox approve-all-button"
          (click)="approveAll()"
          *ngIf=" currentUser && currentUser.hasQcApprovalPermission && records.length > 0"
        >
          <input
            type="checkbox"
            [attr.checked]="(selected.length > 0 && selected.length === records.length) ? 'checked' : null"
          />
        </label>

        <span class="datatable-header-cell-label">Approved</span>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</div>
